import casinoportugal from '../assets/casinoportugal.png'
import lebull from '../assets/lebull.png'
import logo888 from '../assets/888.png'

export const casinoData = [
  {
    containerId: "07de2a5",
    brandId: "88",
    name: "888 Casino",
    logoUrl: logo888,
    affiliateLink: "https://ic.aff-handler.com/C/48417?sr=2021798",
    description: "Marca reconhecida mundialmente e licenciada em Portugal, o 888 Casino oferece slots de alta qualidade, jogos com dealer ao vivo e títulos exclusivos com gráficos avançados. Ideal para quem procura variedade e confiança.",
    ratingValue: "4.9",
    ratingText: "Excelente",
    starFills: ["100%", "100%", "100%", "100%", "90%"],
    terms: "Full T&Cs apply. 18+. New players only. Eligibility restrictions apply. www.gambleaware.org"
  },
  {
    containerId: "b601fdf",
    brandId: "bll",
    name: "Lebull",
    logoUrl: lebull,
    affiliateLink: "https://www.lebull.pt/?partner=p70998p72043p5fbb#registration",
    description: "A Lebull combina apostas desportivas e jogos de casino numa plataforma moderna e fácil de usar, licenciada em Portugal. Oferece slots populares e jogos ao vivo, com promoções frequentes para jogadores fiéis.",
    ratingValue: "4.3",
    ratingText: "Excelente",
    starFills: ["100%", "100%", "100%", "100%", "30%"],
    terms: "Full T&Cs apply. 18+. New players only. Eligibility restrictions apply. www.gambleaware.org"
  },
  {
    containerId: "47a89ad",
    brandId: "cpt",
    name: "Casino Portugal",
    logoUrl: casinoportugal,
    affiliateLink: "https://tracker-pm2.casinoportugal.pt/link?btag=85116035_380423",
    description: "Um dos pioneiros no mercado português, o Casino Portugal disponibiliza uma seleção sólida de jogos e uma plataforma intuitiva, pensada para o público nacional. Destaca-se pelo excelente apoio ao cliente e desempenho em dispositivos móveis.",
    ratingValue: "3.9",
    ratingText: "Bom",
    starFills: ["100%", "100%", "100%", "90%", "0%"],
    terms: "Full T&Cs apply. 18+. New players only. Eligibility restrictions apply. www.gambleaware.org"
  }
];
export const accordionData = [
  {
    id: "2090",
    title: "Licenciamento & Regulação",
    containerId: "43df761",
    widgetId: "402e5e4",
    content: "Todos os casinos listados aqui são totalmente regulamentados pelo Serviço de Regulação e Inspeção de Jogos (SRIJ), a autoridade de jogos de Portugal. Isto garante um ambiente seguro para os jogadores e assegura que os casinos operam de acordo com rigorosos critérios nacionais.",
    isOpen: true
  },
  {
    id: "2091",
    title: "Ofertas de Bónus",
    containerId: "96bc9c2",
    widgetId: "a537b6a",
    content: "Comparamos os diferentes bónus de boas-vindas e promoções disponíveis, incluindo giros grátis sem requisitos de aposta, bónus de depósito e recompensas de fidelidade. Focamo-nos na justiça, clareza dos termos e no valor real dos bónus.",
    isOpen: false
  },
  {
    id: "2092",
    title: "Seleção de Jogos",
    containerId: "8fac34e",
    widgetId: "5722576",
    content: "De slots clássicos a mesas de casino ao vivo, fornecemos uma visão detalhada da oferta de jogos, incluindo os tipos de jogos disponíveis e os fornecedores de software que os alimentam (ex. NetEnt, Microgaming, Playtech).",
    isOpen: false
  },
  {
    id: "2093",
    title: "Métodos de Pagamento",
    containerId: "19e0e1b",
    widgetId: "89d1597",
    content: "A disponibilidade de opções de pagamento seguras e convenientes é crucial para uma experiência de jogo tranquila. Analisamos os métodos de depósito e levantamento, incluindo opções populares como PayPal, transferências bancárias, Visa e sistemas de pagamento portugueses locais como o MB Way.",
    isOpen: false
  },
  {
    id: "2094",
    title: "Suporte ao Cliente",
    containerId: "37affe3",
    widgetId: "e6ef50a",
    content: "O suporte ao cliente fiável é essencial para resolver rapidamente quaisquer problemas. Avaliamos os canais de apoio (Chat Ao Vivo, Email, Telefone) e os tempos de resposta.",
    isOpen: false
  },
  {
    id: "2095",
    title: "Compatibilidade Móvel",
    containerId: "2824fc7",
    widgetId: "3c6b019",
    content: "Muitos jogadores preferem jogar em movimento. Comparamos a experiência móvel, desde sites totalmente otimizados até apps móveis dedicadas para iOS e Android.",
    isOpen: false
  }
]; 